import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    post: null,
    images: {
      logo: require("../assets/truecaller.svg"),
      header: require("../assets/header.jpg")
    },
    categories: [],
    posts: []
  },
  mutations: {
    set_post(state, value) {
      state.post = value;
    },
    set_Categories(state, value){
      state.categories = value;
    },
    set_Posts(state, value){
      state.posts = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
